import { assetsUrl } from 'sly/config';

export const assetPath = (url) => `${assetsUrl}/${url}`;
